import validate from '../../../services/reduxValidate.js'

export default function (data) {
  return validate(data, {
    'title': {presence: {allowEmpty: false}},
    'company': {presence: {allowEmpty: false}},
    'start': {isoDate: true, presence: {allowEmpty: false}},
    'end': {isoDate: true, presence: {allowEmpty: false}},
  })
}